module.exports = __webpack_public_path__ + "img/background_sepid.8b21dd2b.webp";